export const usersData = [
  {
    name: 'Jan',
    'Active Users': 4000,
  },
  {
    name: 'Feb',
    'Active Users': 3000,
  },
  {
    name: 'Mar',
    'Active Users': 5000,
  },
  {
    name: 'Apr',
    'Active Users': 4000,
  },
  {
    name: 'May',
    'Active Users': 3000,
  },
  {
    name: 'Jun',
    'Active Users': 2000,
  },
  {
    name: 'Jul',
    'Active Users': 4000,
  },
  {
    name: 'Agu',
    'Active Users': 3000,
  },
  {
    name: 'Sep',
    'Active Users': 4000,
  },
  {
    name: 'Oct',
    'Active Users': 1000,
  },
  {
    name: 'Nov',
    'Active Users': 4000,
  },
  {
    name: 'Dec',
    'Active Users': 3000,
  },
];

export const userRows = [
  {
    id: 1,
    username: 'Jon Snow ',
    avatar:
      'https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    email: 'example@me.com',
    status: 'active',
    transactions: 'EGP1243',
  },
  {
    id: 2,
    username: 'Cersei Lannister ',
    avatar:
      'https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    email: 'example@me.com',
    status: 'active',
    transactions: 'EGP1243',
  },
  {
    id: 3,
    username: 'Jaime Lannister ',
    avatar:
      'https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    email: 'example@me.com',
    status: 'active',
    transactions: 'EGP1243',
  },
  {
    id: 4,
    username: 'Arya Stark ',
    avatar:
      'https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    email: 'example@me.com',
    status: 'active',
    transactions: 'EGP1243',
  },
  {
    id: 5,
    username: 'Daenerys Targaryen ',
    avatar:
      'https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    email: 'example@me.com',
    status: 'active',
    transactions: 'EGP1243',
  },
  {
    id: 6,
    username: 'ull Melisandre',
    avatar:
      'https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    email: 'example@me.com',
    status: 'active',
    transactions: 'EGP1243',
  },
  {
    id: 7,
    username: 'Ferrara Clifford ',
    avatar:
      'https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    email: 'example@me.com',
    status: 'active',
    transactions: 'EGP1243',
  },
  {
    id: 8,
    username: 'Rossini Frances ',
    avatar:
      'https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    email: 'example@me.com',
    status: 'active',
    transactions: 'EGP1243',
  },
  {
    id: 9,
    username: 'Harvey Roxie ',
    avatar:
      'https://images.pexels.com/photos/4172933/pexels-photo-4172933.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    email: 'example@me.com',
    status: 'active',
    transactions: 'EGP1243',
  },
];

export const productImages = [
  'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/14590826/2021/7/9/f5efb60f-60aa-48fa-9e53-2a342e62d8661625808738696-Calvin-Klein-Jeans-Men-Tshirts-9031625808738146-1.jpg',
  'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/14590826/2021/7/9/94a7233d-d2a9-4935-a204-57d55e97a53a1625808738680-Calvin-Klein-Jeans-Men-Tshirts-9031625808738146-3.jpg',
  'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/14590826/2021/7/9/c7dba4a9-6b43-4714-9aa2-a197adf49aca1625808738671-Calvin-Klein-Jeans-Men-Tshirts-9031625808738146-4.jpg',
  'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/14590826/2021/7/9/738b8c66-32ea-4748-a504-0b2a6fadf7481625808738660-Calvin-Klein-Jeans-Men-Tshirts-9031625808738146-5.jpg',
  'https://assets.myntassets.com/h_1440,q_90,w_1080/v1/assets/images/14590826/2021/7/9/522d522a-d6d6-47b9-9ea2-10ada95365491625808738688-Calvin-Klein-Jeans-Men-Tshirts-9031625808738146-2.jpg',
];

export const products = [
  {
    _id: '625dbbe7e6b7ac266daba405',
    productName: 'Carman V Neck Rib Tank',
    categoryName: 'Casual Tops',
    descriptions: 'Casual Tops',
    price: 1000,
    quantity: 10,
    images: [
      {
        public_id: 'e-commerce-fwd/vqrve8tgv5jzzas9smfs',
        url: 'https://www.dotti.com.au/DT/aurora/images/products/large/586212_blackshag_back_l.jpg?i10c=img.resize(width:320)',
      },
      {
        public_id: 'e-commerce-fwd/ivo2lmnam4zqzyugndvx',
        url: 'https://www.dotti.com.au/DT/aurora/images/products/large/586212_blackshag_l.jpg?i10c=img.resize(width:320)',
      },
    ],
    createdAt: '2022-04-18T19:28:39.885Z',
    updatedAt: '2022-04-18T23:03:38.770Z',
    __v: 0,
  },
  {
    _id: '625dbbe7e6b7ac266daba405',
    productName: 'Carman V Neck Rib Tank',
    categoryName: 'Casual Tops',
    descriptions: 'Casual Tops',
    price: 1000,
    quantity: 10,
    images: [
      {
        public_id: 'e-commerce-fwd/vqrve8tgv5jzzas9smfs',
        url: 'https://www.dotti.com.au/DT/aurora/images/products/large/545734_emerald_l.jpg?i10c=img.resize(width:320)',
      },
      {
        public_id: 'e-commerce-fwd/ivo2lmnam4zqzyugndvx',
        url: 'https://www.dotti.com.au/DT/aurora/images/products/large/545734_emerald_back_l.jpg?i10c=img.resize(width:320)',
      },
    ],
    createdAt: '2022-04-18T19:28:39.885Z',
    updatedAt: '2022-04-18T23:03:38.770Z',
    __v: 0,
  },
  {
    _id: '625dbbe7e6b7ac266daba405',
    productName: 'Carman V Neck Rib Tank',
    categoryName: 'Casual Tops',
    descriptions: 'Casual Tops',
    price: 1000,
    quantity: 10,
    images: [
      {
        public_id: 'e-commerce-fwd/vqrve8tgv5jzzas9smfs',
        url: 'https://www.dotti.com.au/DT/aurora/images/products/large/525886_rose_back_l.jpg?i10c=img.resize(width:320)',
      },
      {
        public_id: 'e-commerce-fwd/ivo2lmnam4zqzyugndvx',
        url: 'https://www.dotti.com.au/DT/aurora/images/products/large/525886_rose_l.jpg?i10c=img.resize(width:320)',
      },
    ],
    createdAt: '2022-04-18T19:28:39.885Z',
    updatedAt: '2022-04-18T23:03:38.770Z',
    __v: 0,
  },
  {
    _id: '625dbbe7e6b7ac266daba405',
    productName: 'Carman V Neck Rib Tank',
    categoryName: 'Casual Tops',
    descriptions: 'Casual Tops',
    price: 1000,
    quantity: 10,
    images: [
      {
        public_id: 'e-commerce-fwd/vqrve8tgv5jzzas9smfs',
        url: 'https://www.dotti.com.au/DT/aurora/images/products/large/565959_red_back_l.jpg?i10c=img.resize(width:320)',
      },
      {
        public_id: 'e-commerce-fwd/ivo2lmnam4zqzyugndvx',
        url: 'https://www.dotti.com.au/DT/aurora/images/products/large/565959_red_l.jpg?i10c=img.resize(width:320)',
      },
    ],
    createdAt: '2022-04-18T19:28:39.885Z',
    updatedAt: '2022-04-18T23:03:38.770Z',
    __v: 0,
  },
  {
    _id: '625dbbe7e6b7ac266daba405',
    productName: 'Carman V Neck Rib Tank',
    categoryName: 'Casual Tops',
    descriptions: 'Casual Tops',
    price: 1000,
    quantity: 10,
    images: [
      {
        public_id: 'e-commerce-fwd/vqrve8tgv5jzzas9smfs',
        url: 'https://www.dotti.com.au/DT/aurora/images/products/large/586212_blackshag_back_l.jpg?i10c=img.resize(width:320)',
      },
      {
        public_id: 'e-commerce-fwd/ivo2lmnam4zqzyugndvx',
        url: 'https://www.dotti.com.au/DT/aurora/images/products/large/586212_blackshag_l.jpg?i10c=img.resize(width:320)',
      },
    ],
    createdAt: '2022-04-18T19:28:39.885Z',
    updatedAt: '2022-04-18T23:03:38.770Z',
    __v: 0,
  },
  {
    _id: '625dbbe7e6b7ac266daba405',
    productName: 'Carman V Neck Rib Tank',
    categoryName: 'Casual Tops',
    descriptions: 'Casual Tops',
    price: 1000,
    quantity: 10,
    images: [
      {
        public_id: 'e-commerce-fwd/vqrve8tgv5jzzas9smfs',
        url: 'https://www.dotti.com.au/DT/aurora/images/products/large/545734_emerald_l.jpg?i10c=img.resize(width:320)',
      },
      {
        public_id: 'e-commerce-fwd/ivo2lmnam4zqzyugndvx',
        url: 'https://www.dotti.com.au/DT/aurora/images/products/large/545734_emerald_back_l.jpg?i10c=img.resize(width:320)',
      },
    ],
    createdAt: '2022-04-18T19:28:39.885Z',
    updatedAt: '2022-04-18T23:03:38.770Z',
    __v: 0,
  },
  {
    _id: '625dbbe7e6b7ac266daba405',
    productName: 'Carman V Neck Rib Tank',
    categoryName: 'Casual Tops',
    descriptions: 'Casual Tops',
    price: 1000,
    quantity: 10,
    images: [
      {
        public_id: 'e-commerce-fwd/vqrve8tgv5jzzas9smfs',
        url: 'https://www.dotti.com.au/DT/aurora/images/products/large/525886_rose_back_l.jpg?i10c=img.resize(width:320)',
      },
      {
        public_id: 'e-commerce-fwd/ivo2lmnam4zqzyugndvx',
        url: 'https://www.dotti.com.au/DT/aurora/images/products/large/525886_rose_l.jpg?i10c=img.resize(width:320)',
      },
    ],
    createdAt: '2022-04-18T19:28:39.885Z',
    updatedAt: '2022-04-18T23:03:38.770Z',
    __v: 0,
  },
  {
    _id: '625dbbe7e6b7ac266daba405',
    productName: 'Carman V Neck Rib Tank',
    categoryName: 'Casual Tops',
    descriptions: 'Casual Tops',
    price: 1000,
    quantity: 10,
    images: [
      {
        public_id: 'e-commerce-fwd/vqrve8tgv5jzzas9smfs',
        url: 'https://www.dotti.com.au/DT/aurora/images/products/large/565959_red_back_l.jpg?i10c=img.resize(width:320)',
      },
      {
        public_id: 'e-commerce-fwd/ivo2lmnam4zqzyugndvx',
        url: 'https://www.dotti.com.au/DT/aurora/images/products/large/565959_red_l.jpg?i10c=img.resize(width:320)',
      },
    ],
    createdAt: '2022-04-18T19:28:39.885Z',
    updatedAt: '2022-04-18T23:03:38.770Z',
    __v: 0,
  },
];

export const sliderItems = [
  {
    id: 1,
    img: 'https://the-lama-shop.vercel.app/_next/image?url=%2F7.webp&w=1920&q=75',
    title: 'SUMMER SALE',
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: 'f5fafd',
  },
  {
    id: 2,
    img: 'https://i.ibb.co/DG69bQ4/2.png',
    title: 'AUTUMN COLLECTION',
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: 'fcf1ed',
  },
  {
    id: 3,
    img: 'https://i.ibb.co/cXFnLLV/3.png',
    title: 'LOUNGEWEAR LOVE',
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: 'fbf0f4',
  },
];

export const categories = [
  {
    id: 1,
    img: 'https://images.pexels.com/photos/5886041/pexels-photo-5886041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    title: 'SHIRT STYLE!',
  },
  {
    id: 2,
    img: 'https://images.pexels.com/photos/2983464/pexels-photo-2983464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    title: 'LOUNGEWEAR LOVE',
  },
  {
    id: 3,
    img: 'https://images.pexels.com/photos/5480696/pexels-photo-5480696.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500',
    title: 'LIGHT JACKETS',
  },
];
